import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useTranslation } from "@coworker/locales";
import { Text } from "../Atoms/Text";

interface HFBLocationProps {
  hfb: string;
}

export const HFBLocation = ({ hfb }: HFBLocationProps) => {
  const { t } = useTranslation();

  const addOnContent = hfb ? <Text text={hfb} grey /> : "";

  return (
    <FixaListViewItem
      title={t("hfbLocationInStoreString")}
      addOn={addOnContent}
      emphasised
      inset
    />
  );
};
